import { useSyncExternalStore } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function subscribe(onChange: () => void): () => void {
  const media = window.matchMedia(QUERY)
  media.addEventListener('change', onChange)

  return (): void => media.removeEventListener('change', onChange)
}

/**
 * Whether the visitor asked for reduced motion, live: turning the setting on stops the animations
 * without a reload, as production's `reducedMotion` change listeners do (`app.js:4`). The server
 * snapshot is `true`, so nothing starts moving before the real preference is known.
 */
export default function useReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => true,
  )
}
